import { MilestoneSetsLibrary } from '@/components/milestones/MilestoneSetsLibrary';

export default function MilestoneSetsPage() {
  return (
    <div className="container mx-auto p-6 max-w-7xl">
      <MilestoneSetsLibrary />
    </div>
  );
}
